export default __webpack_public_path__ + "static/media/012-Skyscrapper.56dc861a.svg";